import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { ContentLayout, Box } from "@amzn/awsui-components-console";
const Error404 = () => {
  return (
    <div className="centered">
      <ContentLayout>
        <Box variant="h1" textAlign="center">
          404 Error
        </Box>
        <Box variant="h2" textAlign="center">
          Page not found
        </Box>
        <Box variant="p" textAlign="center">
          Click on the link below to go to the homepage
        </Box>
        <Box variant="p" textAlign="center">
          <ReactRouterLink to="/">Claim Intake Homepage</ReactRouterLink>
        </Box>
      </ContentLayout>
    </div>
  );
};
export default Error404;
